import React from 'react';

import TwoStepPayment from './two-step-payment';
import { IPaymentProps } from './types';

const Payment: React.FC<IPaymentProps> = props => {
  return <TwoStepPayment {...props} />;
};

export default Payment;
